import { NavLink } from 'react-router-dom';
import { navigation } from '../../data/fixtures';
import { Icon } from '../Icon';

interface HeaderProps {
  menuOpen: boolean;
  onMenuToggle: () => void;
  onLogin: () => void;
  onRegister: () => void;
}

export function Header({ menuOpen, onMenuToggle, onLogin, onRegister }: HeaderProps) {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="site-header__inner">
        <button className="icon-button site-header__menu-button" type="button" onClick={onMenuToggle} aria-expanded={menuOpen} aria-controls="mobile-drawer" aria-label={menuOpen ? 'Close menu' : 'Open menu'}>
          <Icon name={menuOpen ? 'close' : 'menu'} />
        </button>
        <NavLink className="brand" to="/" aria-label="22Play home">
          <span className="brand__number">22</span><span className="brand__word">PLAY</span>
        </NavLink>
        <nav className="desktop-navigation" aria-label="Primary navigation">
          {navigation.map((item) => (
            <NavLink key={item.path} to={item.path} className={({ isActive }) => `desktop-navigation__link${isActive ? ' is-active' : ''}`}>
              {item.label}
              {item.badge && <span className="navigation-badge">{item.badge}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="site-header__actions">
          <button className="header-action header-action--login" type="button" onClick={onLogin}>Log in</button>
          <button className="header-action header-action--register" type="button" onClick={onRegister}>Registration</button>
          <button className="icon-button site-header__language" type="button" aria-label="Language: English">
            <Icon name="globe" /><span>EN</span><Icon name="chevron" />
          </button>
        </div>
      </div>
      <nav className="mobile-navigation" aria-label="Quick navigation">
        {navigation.slice(0, 8).map((item) => (
          <NavLink key={item.path} to={item.path} className={({ isActive }) => `mobile-navigation__link${isActive ? ' is-active' : ''}`}>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}

export function MobileDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <>
      <div className={`drawer-backdrop${open ? ' is-open' : ''}`} onClick={onClose} aria-hidden="true" />
      <aside id="mobile-drawer" className={`mobile-drawer${open ? ' is-open' : ''}`} aria-hidden={!open}>
        <div className="mobile-drawer__header">
          <span className="mobile-drawer__title">Menu</span>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Close menu"><Icon name="close" /></button>
        </div>
        <nav className="mobile-drawer__nav" aria-label="Full navigation">
          {navigation.map((item) => (
            <NavLink key={item.path} to={item.path} onClick={onClose} className={({ isActive }) => `mobile-drawer__link${isActive ? ' is-active' : ''}`}>
              <span>{item.label}</span><Icon name="chevron" />
            </NavLink>
          ))}
          <NavLink to="/results" onClick={onClose} className="mobile-drawer__link"><span>Results</span><Icon name="chevron" /></NavLink>
          <NavLink to="/statistics" onClick={onClose} className="mobile-drawer__link"><span>Statistics</span><Icon name="chevron" /></NavLink>
        </nav>
      </aside>
    </>
  );
}
